<main class="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden px-3 py-4 sm:px-4 lg:px-5">
  <div class="grid min-h-0 flex-1 grid-rows-[auto_minmax(0,1fr)] gap-4 lg:grid-cols-[14rem_minmax(0,1fr)] lg:grid-rows-1">
    <aside class="min-w-0 shrink-0 border-b border-line pb-3 lg:h-full lg:border-b-0 lg:border-r lg:pb-0 lg:pr-3" aria-label="Preferências de conversas">
      <nav class="flex gap-1 overflow-x-auto text-sm lg:flex-col lg:overflow-visible">
        @for (item of preferenceItems; track item.path) {
          <a
            class="conversation-preferences-link flex min-h-10 shrink-0 items-center gap-3 rounded-lg px-2.5 font-medium text-muted transition hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30 lg:shrink"
            [routerLink]="item.path.slice(preferencePathPrefix.length)"
            routerLinkActive="conversation-preferences-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <ng-icon [name]="item.icon" size="18" aria-hidden="true" class="shrink-0" />
            <span class="truncate">{{ item.label }}</span>
          </a>
        }
      </nav>
    </aside>

    <section class="min-h-0 min-w-0 overflow-y-auto overflow-x-hidden pr-1">
      <router-outlet />
    </section>
  </div>
</main>
